import styled from 'styled-components';

export const StyledRow = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 16px;
  align-items: start;
  .actions {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`;
